$.fn.setupDotNav = function () {

    this.find('.dot-nav').each(function (i, el) {
        
        var dotNavEl = $(el), changeDot = function (btn) {

            btn.siblings().removeClass('active');
            btn.addClass('active');

            if (dotNavEl.data('target')) {

                var t = $(dotNavEl.data('target')), children = t.children();
                children.hide();
                $(children[btn.index()]).show();
            }
        }, navToDot = function (index) {

            var dots = dotNavEl.children();
            if (index >= dots.length) index = 0;
            else if(index < 0) index = dots.length - 1;
            $(dots[index]).click();
        };
        dotNavEl.off('click.cafm').on('click.cafm', 'button', function (e) {
            changeDot($(e.currentTarget));
        })

        changeDot(dotNavEl.find('> button.active'));

        if (dotNavEl.data('target')) {
            cafm.util.swipe.setupSwipeNav({
                target: $(dotNavEl.data('target')),
                forward: function () {

                    var index = dotNavEl.find('button.active').index();
                    index++;
                    navToDot(index);
                },
                backward: function () {

                    var index = dotNavEl.find('button.active').index();
                    index--;
                    navToDot(index);
                },
                preventDefault: true
            });
        }
    });

    return this;
}

window.nav = cafm.nav = {
    router: null,
    navigatable: null,
    isNav: function () {

        if (arguments.length) {

            var args = arguments;
            if (isArray(args[0])) {
                args = args[0];
            }
            for (var i = 0; i < args.length; i++) {

                var a = args[i];
                if (a === nav.navigatable) {

                    return true;
                }
            }
        }
        return false;
    },
    historyData: function () {

        return cafm.cache.get(cafm.res.consts.CacheKey_SharedHistory) || [];
    },
    historyItem: function (key) {

        return cafm.util.find(cafm.nav.historyData(), function (item) {
            return item.itemKey == key;
        });
    },
    addToHistory: function (props, router) {

        var hKey = $('#historyList').data('key') || cafm.res.consts.CacheKey_SharedHistory;
        if (hKey) {

            // get history length
            var hLength = $('#historyList').data('length');
            if (!hLength) hLength = 20;

            // get history items from cache or new array if not found
            var items = cafm.cache.get(hKey, []);

            // if there are items check for the current key
            if (items.length) {

                // remove the existing item
                cafm.util.removeWhere(items, function (item) {
                    return item.itemKey == props.itemKey;
                });
            }

            // get current route info and assign description

            var routeInfo;
            if (router) {

                routeInfo = router.getCurrentRouteInfo(props.navUrl);
            }
            else {

                routeInfo = {

                    navUrl: props.navUrl
                };
            }

            props.itemViewed = kendo.toString(new Date(), 'g');

            // merge props into route info
            $.extend(routeInfo, props);

            // set path name
            routeInfo.pathName = window.location.pathname;

            // insert route info at index 0
            var len = items.unshift(routeInfo);

            // pop the array if history length is exceeded
            if (len > hLength) {
                items.pop();
            }

            // cache the history
            cafm.cache.set(hKey, items);

            // now refresh history
            if (window.HistoryList) {
                HistoryList.refresh();
            }
        }
    },
    getNavTree: function () {

        return $('#' + cafm.res.consts.ElementId_NavTree + ', #filter-tree');
    },
    getKendoNavTree: function () {

        return nav.getNavTree().data('kendoTreeView');
    },
    getFilterTree: function () {

        return $('#filter-tree');
    },
    getKendoFilterTree: function () {

        return nav.getFilterTree().getKendoTreeView();
    },
    findNavTreeElements: function (selector) {

        return $(selector, nav.getNavTree());
    },
    findFilterTreeElements: function (selector) {

        return $(selector, nav.getFilterTree());
    }
}